import { getRequestProps } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
export function CaptorRequestFormatter(message) {
    let { baseUrl, endpoint, method, headers, body, params } = getRequestProps(ConnectionNames.captor, message);
    headers["Content-Type"] = "application/json; charset=utf-8";
    body = JSON.stringify(params);
    return new Request(`${baseUrl}${endpoint}`, {
        method,
        headers,
        body
    });
}
//# sourceMappingURL=CaptorRequestFormatter.js.map